import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import { Image, Mobile, Desktop } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var DEVICE_BASED_COMPONENTS = {
  desktop: Desktop,
  mobile: Mobile
};

function isMultipleAssets(assets) {
  return assets.desktop !== undefined || assets.mobile !== undefined;
}

var LazyImageAdapter = function LazyImageAdapter(_ref) {
  var assets = _ref.assets,
      rootRef = _ref.rootRef;

  if (isMultipleAssets(assets)) {
    var assetEntries = Object.entries(assets).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          asset = _ref3[1];

      return DEVICE_BASED_COMPONENTS[key] && (asset === null || asset === void 0 ? void 0 : asset.src);
    });
    return /*#__PURE__*/_jsx(_Fragment, {
      children: assetEntries.map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            asset = _ref5[1];

        var WrapperComponent = DEVICE_BASED_COMPONENTS[key];

        var image = /*#__PURE__*/_jsx(Image, {
          name: asset.alt,
          width: asset.width,
          height: asset.height,
          src: asset.src,
          rootRef: rootRef
        }, key);

        if (assetEntries.length > 1) {
          return /*#__PURE__*/_jsx(WrapperComponent, {
            $block: true,
            children: image
          }, key);
        }

        return image;
      })
    });
  }

  if (!assets.src) {
    return null;
  }

  return /*#__PURE__*/_jsx(Image, {
    name: assets.alt,
    width: assets.width,
    height: assets.height,
    src: assets.src,
    rootRef: rootRef
  });
};

export default LazyImageAdapter;